import React, { useEffect } from "react";
import { Header } from "../../components/Header/Header";
import { Title } from "../../components/Title/Title";
import { Text } from "../../components/Text/Text";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

export const Charging = ({ withBg }) => {

  useEffect(() => {
    withBg(true)
  }, [withBg])

  return (
    <div className="content">
      <Header />
      <Title title="Заряджання розпочато" />
      <div className="content-wrap">
        <Text text={
          'Lorem ipsum dolor sit amet consectetur. Iaculis netus sed nulla posuere vel aliquet sed. '
        } />
        <img src="/images/payment-success.png" alt="success" />
        <Link className="button" to="/">На головний екран</Link>
      </div>
    </div>
  );
};

Charging.propTypes = {
  withBg: PropTypes.func.isRequired
};

export default Charging;